var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "nav-item" }, [
    _c(
      "a",
      {
        staticClass: "nav-link",
        class: { active: _vm.currentTab == _vm.name },
        attrs: { href: `#${_vm.name}`, help: _vm.currentTab },
        on: {
          click: function ($event) {
            _vm.currentTab = _vm.name
          },
        },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }